import { cn } from "../../../lib/utils"
import { getModelIcon, getModelDisplayName } from "../../ai-agent/utils/getModelIcon"
import { UserAvatar } from "../../../components/ui/user-avatar"
import type { GlobalAIMessage as GlobalAIMessageType } from "../types"

interface GlobalAIMessageProps {
  message: GlobalAIMessageType
  isStreaming?: boolean
}

export function GlobalAIMessage({ message, isStreaming }: GlobalAIMessageProps) {
  const isAssistant = message.role === "assistant"

  return (
    <div className={cn("flex gap-3", isAssistant ? "items-start" : "items-start")}>
      {/* Avatar */}
      {isAssistant ? (
        <img
          src={getModelIcon(message.model_used, "light")}
          alt={getModelDisplayName(message.model_used)}
          className="flex-shrink-0 w-[42px] h-[42px] object-contain rounded-full shadow-[0_1px_4px_rgba(0,0,0,0.08)]"
        />
      ) : (
        <UserAvatar className="flex-shrink-0 h-[42px] w-[42px]" />
      )}

      {/* Content */}
      <div className="flex-1 min-w-0">
        {/* Tool calls summary (for completed messages) */}
        {isAssistant && !isStreaming && message.tool_calls && message.tool_calls.length > 0 && (
          <div className="space-y-1 mb-2">
            {message.tool_calls.map((tool, index) => (
              <div
                key={index}
                className="text-xs text-muted-foreground flex items-center gap-2"
              >
                <span className="inline-block w-2 h-2 bg-primary/50 rounded-full" />
                <span>{tool.output_summary || tool.name}</span>
              </div>
            ))}
          </div>
        )}

        <div
          className={cn(
            "text-sm leading-relaxed",
            isAssistant ? "text-foreground" : "text-foreground",
            isStreaming && "animate-pulse"
          )}
        >
          {message.content || (isStreaming && <span className="text-muted-foreground">...</span>)}
        </div>
      </div>
    </div>
  )
}
